import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  Fragment,
} from "react";
import {
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
  FaRegCalendarAlt,
  FaTimes,
  FaRegClock,
} from "react-icons/fa";
import { Table } from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";
import * as apicall from "../../components/Apicall";
import NewAppointment from "../../components/Appointment/NewAppointment";
import { LuClock } from "react-icons/lu";
import { HiOutlineUsers } from "react-icons/hi2";
import { LuClipboardCheck } from "react-icons/lu";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import VectorBg from "../../assets/images/Vector.svg";
import CustomCalendar from "./FullCalendar";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import serviceNames from "../../data/serviceNames.json";
import UserContext from "../../components/context/UserContext";
import ExcelIcon from "../../assets/images/vscode-icons_file-type-excel.svg";
import Skeleton from "../../components/Loader/Skeleton";
import { IoCalendarOutline } from "react-icons/io5";
import { MdArrowBack } from "react-icons/md";

const timeSlotStyles = {
  dropdownContainer: {
    position: "relative",
  },
  timeSlotList: {
    position: "absolute",
    top: "100%",
    left: 0,
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    maxHeight: "300px",
    width: "100%",
    overflowY: "auto",
    zIndex: 1000,
    padding: "12px",
    marginTop: "4px",
    border: "1px solid #E3EBF8",
    boxSizing: "border-box",
  },
  timeSlotItem: {
    backgroundColor: "#F0F7FF",
    borderRadius: "6px",
    padding: "8px 12px",
    margin: "4px 0",
    cursor: "pointer",
    fontSize: "12px",
    border: "1px solid #E3EBF8",
    width: "100%",
    textAlign: "left",
    transition: "all 0.2s ease",
    color: "#212529",
    "&:hover": {
      backgroundColor: "#E3F2FF",
      borderColor: "#0D6EFD",
    },
  },
  timeSlotItemSelected: {
    backgroundColor: "#E3F2FF",
    border: "1px solid #0D6EFD",
    color: "#0D6EFD",
  },
  timeInput: {
    height: "40px",
    backgroundColor: "white",
    border: "1px solid #E3EBF8",
    borderRadius: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "14px",
    color: "#212529",
  },
};

const chipGridStyles = {
  grid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    justifyContent: "flex-start",
  },
  chip: {
    display: "inline-block",
    minWidth: "80px",
    padding: "8px 12px",
    fontSize: "12px",
    textAlign: "center",
    borderRadius: "14px",
    border: "1px solid #7A5AF8",
    color: "#7A5AF8",
    cursor: "pointer",
    backgroundColor: "#fff",
    userSelect: "none",
  },
  chipSelected: {
    backgroundColor: "#7A5AF8",
    color: "#fff",
    fontWeight: "500",
  },
  hiddenCheckbox: {
    display: "none",
  },
};

const NewDashboard = () => {
  const navigate = useNavigate();
  const { id: vendorIdFromParams } = useParams();
  const [activeTab, setActiveTab] = useState("dashboard");

  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  const [statusFilter, setStatusFilter] = useState("All");
  const [orderCounts, setOrderCounts] = useState({
    total: 0,
    progress: 0,
    completed: 0,
    cancelled: 0,
  });

  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [calendarPickerOpen, setCalendarPickerOpen] = useState(false);
  const today = new Date();
  const [dateRange, setDateRange] = useState([today, today]);
  const [startDate, endDate] = dateRange;
  const [tableDateRange, setTableDateRange] = useState([today, today]);
  const [tableStartDate, tableEndDate] = tableDateRange;
  const [calendarDate, setCalendarDate] = useState(today);
  const currentDate = calendarDate.toISOString().split("T")[0];
  const [vendorId, setVendorId] = useState(null);
  const [holidaysDates, setHolidaysDates] = useState([]);
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [serviceId, setServiceId] = useState("");

  const [formData, setFormData] = useState({
    mobileNumber: "+971",
    patientName: "",
    age: "",
    dob: "",
    gender: "",
    insuranceNumber: "",
    insuranceProvider: "",
    specialization: "",
    doctorName: "",
    appointmentDate: "",
    dependentId: "",
    selectedTimeSlots: [],
  });
  const [doctorAvailability, setDoctorAvailability] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [isLoadingSlots, setIsLoadingSlots] = useState(false);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [calendarAppointmentData, setCalendarAppointmentData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDetailsFetched, setIsDetailsFetched] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [doctorDropdownOpen, setDoctorDropdownOpen] = useState(false);
  const [appointmentSearchTerm, setAppointmentSearchTerm] = useState("");
  const [doctorPage, setDoctorPage] = useState(1);
  const [hasMoreDoctors, setHasMoreDoctors] = useState(true);
  const [isLoadingMoreDoctors, setIsLoadingMoreDoctors] = useState(false);
  const DOCTORS_PER_PAGE = 30;

  // Add this new state for debounce
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Add these refs after other useRef declarations
  const insuranceProviderRef = useRef(null);
  const specializationRef = useRef(null);
  const doctorDropdownRef = useRef(null);
  const appointmentSearchInputRef = useRef(null);
  const page = 0;
  const limit = 10;

  // Add states for appointment search dropdown
  const [showAppointmentSearchDropdown, setShowAppointmentSearchDropdown] =
    useState(false);
  const [selectedDoctorForFilter, setSelectedDoctorForFilter] = useState(null);
  const [searchDisplayValue, setSearchDisplayValue] = useState("");

  useEffect(() => {
    getBookingByDate();
    refreshVendorData();
  }, []);

  const getBookingByDate = async () => {
    try {
      setLoading(true);
      const get_booking_data = await apicall.get(`get_ezp_booking`);
      console.log("get_booking_data-----", get_booking_data);
      let allData = get_booking_data?.data;
      const counts = {
        total: allData.length,
        progress: allData.filter(
          (item) => item.booking_status === "In Progress"
        ).length,
        completed: allData.filter((item) => item.booking_status === "Completed")
          .length,
        cancelled: allData.filter((item) => item.booking_status === "Cancelled")
          .length,
      };
      setOrderCounts(counts);
      setTableData(allData);
      setLoading(false);
    } catch (e) {
      console.log("err----", e);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const getVendorId = () => {
      const vendorIdFromStorage = localStorage.getItem("vendorId");
      return vendorIdFromParams || vendorIdFromStorage;
    };

    const fetchInitialData = (vendorId) => {
      const todayStr = formatDate(new Date());

      setVendorId(vendorId);
      localStorage.setItem("vendorId", vendorId);

      fetchDoctors(vendorId);
      // fetchAppointmentDataByRange(todayStr, todayStr, vendorId, false);
      // fetchAppointmentDataByRange(todayStr, todayStr, vendorId, true);
    };

    // Only run this effect when vendorIdFromParams or vendor.id changes
    if (vendor?.id) {
      fetchInitialData(vendor.id);
    } else {
      const vendorId = getVendorId();
      if (vendorId) {
        fetchInitialData(vendorId);
      } else {
        const retryInterval = setInterval(() => {
          const retryVendorId = getVendorId();
          if (retryVendorId) {
            fetchInitialData(retryVendorId);
            clearInterval(retryInterval);
          }
        }, 1000);
        return () => clearInterval(retryInterval);
      }
    }
  }, [vendorIdFromParams, vendor?.id]);

  // Handle date changes separately
  useEffect(() => {
    if (vendorId) {
      const dateStr = formatDate(selectedDate);
      fetchCalendardata(vendorId, dateStr);
    }
  }, [selectedDate, vendorId]);

  // Simple serviceId initialization
  useEffect(() => {
    if (vendor?.service_id && !serviceId) {
      setServiceId(vendor.service_id);
    }
  }, [vendor, serviceId]);

  // Manual trigger to refresh vendor data if it's null
  useEffect(() => {
    if (!vendor && localStorage.getItem("vendorId")) {
      refreshVendorData();
    }
  }, [vendor, refreshVendorData]);

  // Wait for vendorId to be set in localStorage
  useEffect(() => {
    const checkVendorId = () => {
      const vendorId = localStorage.getItem("vendorId");
      if (vendorId && !vendor) {
        refreshVendorData();
      }
    };

    // Check immediately
    checkVendorId();

    // Set up an interval to check periodically
    const interval = setInterval(checkVendorId, 1000);

    // Clean up interval
    return () => clearInterval(interval);
  }, [vendor, refreshVendorData]);

  const fetchDoctors = async (
    vendorId,
    specializationId = "",
    page = 1,
    isLoadingMore = false,
    searchQuery = ""
  ) => {
    try {
      if (page === 1) {
        setLoading(true);
      } else {
        setIsLoadingMoreDoctors(true);
      }

      let url = `get_service_providers?vendor_id=${vendorId}&role=5&limit=${DOCTORS_PER_PAGE}&page=${page}`;

      if (specializationId) {
        url += `&specilisation=${specializationId}`;
      }

      if (searchQuery && searchQuery.trim() !== "") {
        url += `&name=${encodeURIComponent(searchQuery.trim())}`;
      }

      const response = await apicall.get(url);

      if (response.status === 200) {
        const formattedDoctors = response.data.map((doctor) => ({
          id: doctor.id,
          serviceProvider_id: doctor?.service_provider,
          user_id: doctor.user_id,
          name: `${doctor.first_name} ${doctor.middle_name} ${doctor.last_name}`.trim(),
          specialization: doctor.specilisation, // Include specialization from doctor data
        }));

        if (page === 1) {
          setDoctors(formattedDoctors);
        } else {
          setDoctors((prev) => [...prev, ...formattedDoctors]);
        }

        setHasMoreDoctors(formattedDoctors.length === DOCTORS_PER_PAGE);
        setDoctorPage(page);
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    } finally {
      setLoading(false);
      setIsLoadingMoreDoctors(false);
    }
  };

  //function call to get calendar appointment data

  const fetchCalendardata = useCallback(
    async (vendorId, date = currentDate) => {
      try {
        setLoading(true);
        const response = await apicall.get(
          `get_booking_details/${date}/${vendorId}`
        );

        //     status);
        // const sortedSlots = [...item.time_slots].sort();
        // const start = toFullCalendarDate(item.booking_date, sortedSlots[0]);
        // const totalDuration = item.appointment_duration

        // let d1 = Array(6)
        //   .fill()
        //   .map((_, i) => {
        //     return {
        //       doctor_name: "Raju",
        //       status: 10,
        //       time_slots: ["09:00"],
        //       booking_date: "2025-11-19",
        //       appointment_duration: 30,
        //     };
        //   });

        let d1 = [
          {
            user_name: "Raju",
            service: "Cleaning",
            status: 15,
            time_slots: ["12:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
          {
            user_name: "Linga",
            service: "Cleaning",
            status: 15,
            time_slots: ["10:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
          {
            user_name: "Gopi",
            service: "Cleaning",
            status: 10,
            time_slots: ["09:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
          {
            user_name: "Shahib",
            service: "Cleaning",
            status: 11,
            time_slots: ["13:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
          {
            user_name: "Mani",
            service: "Cleaning",
            status: 11,
            time_slots: ["15:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
          {
            user_name: "Raju",
            service: "Cleaning",
            status: 15,
            time_slots: ["11:00"],
            booking_date: "2025-11-19",
            appointment_duration: 30,
          },
        ];
        console.log("d1---", d1);
        setCalendarAppointmentData(d1);

        if (response.status === 200) {
          // setCalendarAppointmentData(
          //   response.data.filter((item) => item.status !== 14)
          // );
        }
      } catch (error) {
        console.error("Error fetching appointments:", error);
        toast.error("Failed to fetch appointments");
      } finally {
        setLoading(false);
      }
    },
    [currentDate]
  );

  // Add new function for handling calendar date changes
  const handleCalendarDateChange = (date) => {
    setCalendarDate(date);
    setCalendarPickerOpen(false);
    const formattedDate = date.toISOString().split("T")[0];
    fetchCalendardata(vendorId, formattedDate);
  };

  // Modify the changeDate function
  const changeDate = (direction) => {
    const date = new Date(calendarDate);
    date.setDate(date.getDate() + direction);
    setCalendarDate(date);
    setAppointmentSearchTerm("");

    // Clear any existing search timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Fetch appointments for the new date
    const newDate = date.toISOString().split("T")[0];
    fetchCalendardata(vendorId, newDate);
  };

  //function call to fetch the avilable slots
  const fetchDoctorAvailability = async (doctorId, selectedDate) => {
    if (!doctorId || !selectedDate) return;

    try {
      setIsLoadingSlots(true);
      setShowTimeDropdown(false);

      // Format the date to YYYY-MM-DD format
      const formattedDate = new Date(selectedDate).toISOString().split("T")[0];
      const response = await apicall.get(
        `get_available_slots/${doctorId}/${formattedDate}`
      );

      if (response && response.data) {
        const { available_slots, appointment_duration, no_of_slots } =
          response.data;

        // Update doctor availability info
        setDoctorAvailability({
          appointment_duration,
          no_of_slots,
        });

        // Update available time slots
        setAvailableTimeSlots(available_slots || []);
      } else {
        setAvailableTimeSlots([]);
        setDoctorAvailability(null);
      }
    } catch (error) {
      console.error("Error fetching doctor availability:", error);
      toast.error("Failed to fetch available slots");
      setAvailableTimeSlots([]);
      setDoctorAvailability(null);
    } finally {
      setIsLoadingSlots(false);
    }
  };

  const timeSlotRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (timeSlotRef.current && !timeSlotRef.current.contains(event.target)) {
        setShowTimeDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //function call to add event color with respect to the status
  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      // Pending/Upcoming (10) - Light yellow
      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Checked In (11) - Light blue
      11: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      14: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },
      // Completed/Checked Out (15) - Light green
      15: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  // Helper function to format booking time into FullCalendar date format
  const toFullCalendarDate = (bookingDate, bookingTime) => {
    return `${bookingDate}T${bookingTime}:00`; // Assuming bookingTime is in 'HH:mm' format
  };

  const addMinutes = (timeStr, minutesToAdd) => {
    const [hours, minutes] = timeStr?.split(":")?.map(Number);
    const date = new Date();
    date.setHours(hours, minutes + minutesToAdd, 0, 0);
    return date.toTimeString().slice(0, 5); // "HH:mm"
  };

  // Convert calendar appointment data to FullCalendar events
  const appointments = calendarAppointmentData.map((item) => {
    const colors = getStatusColors(item?.status);
    const sortedSlots = [...item.time_slots].sort();
    const start = toFullCalendarDate(item.booking_date, sortedSlots[0]);
    const totalDuration = item.appointment_duration * item.time_slots.length;
    const endTime = addMinutes(sortedSlots[0], totalDuration);
    const end = toFullCalendarDate(item.booking_date, endTime);

    return {
      title: `${item.user_name.trim()} | ${item.service}`,
      search: item.user_name.trim(),
      start,
      end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
      },
      // Optional: Add event class for additional styling
      className: `status-${item?.status || "default"}`,
    };
  });

  //function call to convert date to 12 hours
  const convertTo12Hour = (time24) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 0 to 12
    return `${hour}:${minute} ${ampm}`;
  };

  //function call to on click to set set the appointment details into the side menu
  const handleAppointmentClick = (appointment, currentDate) => {
    fetchDoctorAvailability(appointment?.details?.doctor_id, currentDate);
    fetchDoctorHolidays(appointment?.details?.doctor_id);
  };

  const refreshOverviewTiles = () => {
    if (vendorId) {
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      // Use current date range or default to today
      const currentStartDate = startDate || new Date();
      const currentEndDate = endDate || new Date();
      const startDateStr = formatDate(currentStartDate);
      const endDateStr = formatDate(currentEndDate);

      // Fetch data for overview tiles (isTableView = false)
      // fetchAppointmentDataByRange(startDateStr, endDateStr, vendorId, false);
    }
  };

  // Add useEffect to refresh tiles when calendar data changes
  useEffect(() => {
    if (calendarAppointmentData.length > 0) {
      refreshOverviewTiles();
    }
  }, [calendarAppointmentData]);

  // Function to fetch appointment data based on date range
  const fetchAppointmentDataByRange = async (
    startDate,
    endDate,
    vendorId,
    isTableView = false
  ) => {
    if (!vendorId) {
      console.error("Vendor ID is required");
      return;
    }

    try {
      setLoading(true);
      const response = await apicall.get(
        `get_booking_details/range/${startDate}/${endDate}/${vendorId}`
      );

      if (response.status === 200) {
        // const allData = response.data;
        const allData = [
          {
            "User Name": "Raju",
            Provider: "Agent 1",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 11,
          },
          {
            "User Name": "Gopi",
            Provider: "Agent 3",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 10,
          },
          {
            "User Name": "Neethi",
            Provider: "Agent 3",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 11,
          },
          {
            "User Name": "Linga",
            Provider: "Agent 3",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 12,
          },
          {
            "User Name": "Shahib",
            Provider: "Agent 3",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 11,
          },
          {
            "User Name": "Heavanth",
            Provider: "Agent 3",
            Service: "Cleaning",
            "Service Type": "With Crub",
            "Service Offering": "2 Hour",
            Time: "10 AM",
            Date: "28-11-2025",
            Status: 10,
          },
        ];

        if (isTableView) {
          // Format the data for the table
          // const formattedData = allData.map((item, index) => [
          //   item.patient_name,
          //   item.doctor_name,
          //   convertTo12Hour(item.booking_time),
          //   item.booking_date,
          //   getStatusText(item.status, item.booking_date, item.booking_time),
          //   item.patient_age || "",
          //   item.patient_gender === 1 ? "Male" : "Female",
          //   item.patient_phone || "",
          //   item.id,
          //   item.status,
          //   item.user_id,
          //   item.doctor_id,
          //   item.insurance_provider,
          //   item.insurance_number,
          // ]);

          setTableData(allData);
        } else {
          // Update counts for overview
          const counts = {
            total: allData.length,
            progress: allData.filter((item) => item.Status === 10).length,
            completed: allData.filter((item) => item.Status === 11).length,
            cancelled: allData.filter((item) => item.Status === 12).length,
          };
          setOrderCounts(counts);
          // setAppointmentCounts(counts);
        }
      }
    } catch (error) {
      console.error("Error fetching appointment data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateChange = (update, isTableView = false) => {
    if (isTableView) {
      setTableDateRange(update);
      if (update[0]) {
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const selectedDate = formatDate(update[0]);
        let endDateStr = selectedDate;

        if (update[1]) {
          endDateStr = formatDate(update[1]);
          setOpen(false);
        }

        // Fetch data for the table view
        // fetchAppointmentDataByRange(selectedDate, endDateStr, vendorId, true);
      }
    } else {
      setDateRange(update);
      if (update[0]) {
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const selectedDate = formatDate(update[0]);
        let endDateStr = selectedDate;

        if (update[1]) {
          endDateStr = formatDate(update[1]);
          setOpen(false);
        }

        // Fetch data for the overview section
        // fetchAppointmentDataByRange(selectedDate, endDateStr, vendorId, false);
      }
    }
  };

  const formatDateDisplay = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Add a function to handle tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Don't reset date ranges - maintain the current selection
    setOpen(false);
    setCalendarPickerOpen(false);

    // If switching to table view, use the current overview date range
    if (tab === "table" && vendorId) {
      const formatDate = (date) => {
        if (!date) {
          const today = new Date();
          return `${today.getFullYear()}-${String(
            today.getMonth() + 1
          ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      // Use the current overview date range or default to today if not set
      const currentStartDate = startDate || new Date();
      const currentEndDate = endDate || new Date();

      // Update table date range to match overview date range
      setTableDateRange([currentStartDate, currentEndDate]);

      // Format dates for API call
      const startDateStr = formatDate(currentStartDate);
      const endDateStr = formatDate(currentEndDate);

      // Fetch data for the table view with the same date range
      // fetchAppointmentDataByRange(startDateStr, endDateStr, vendorId, true);
    }
  };

  // Helper function to get status text
  const getStatusText = (status, bookingDate, bookingTime) => {
    // For active appointments (status 10), check if it's in the future
    if (status === 10) {
      const appointmentDateTime = new Date(`${bookingDate}T${bookingTime}`);
      const currentDateTime = new Date();

      if (appointmentDateTime >= currentDateTime) {
        return "Active";
      }
      return "Pending";
    }

    switch (status) {
      case 11:
        return "Checked In";
      case 12:
        return "No Show";
      case 15:
        return "Completed";
      default:
        return "Unknown";
    }
  };

  const getStatus = (data) => {
    switch (data) {
      case 10:
        return "Completed";
      case 11:
        return "In Progress";
      case 12:
        return "Cancelled";
      default:
        return "Unknown";
    }
  };

  // Helper function to get status badge styles
  const getStatusBadgeClass = (status) => {
    const baseStyles = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: "26px",
      borderRadius: "20px",
      borderWidth: "1px",
      padding: "4px 16px",
      gap: "10px",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "1",
      whiteSpace: "nowrap",
    };

    switch (status.toLowerCase()) {
      case "active":
        return {
          ...baseStyles,
          backgroundColor: "#FFEBEE",
          border: "1px solid #D32F2F",
          width: "86px",
          color: "#D32F2F",
        };

      case "pending":
        return {
          ...baseStyles,
          backgroundColor: "#FFF3E0",
          border: "1px solid #FB8C00",
          width: "86px",
          color: "#FB8C00",
        };

      case "no show":
        return {
          ...baseStyles,
          backgroundColor: "#E3F2FD",
          border: "1px solid #1976D2",
          width: "88px",
          color: "#1976D2",
        };

      case "checked in":
        return {
          ...baseStyles,
          backgroundColor: "#F3E5F5",
          border: "1px solid #8E24AA",
          width: "90px",
          color: "#8E24AA",
        };

      case "completed":
        return {
          ...baseStyles,
          backgroundColor: "#FFF9C4",
          border: "1px solid #FBC02D",
          width: "100px",
          color: "#795548",
        };

      default:
        return {
          ...baseStyles,
          backgroundColor: "#F5F5F5",
          border: "1px solid #E0E0E0",
          color: "#000000",
        };
    }
  };

  // Update the overview card click handler
  const renderOverview = () => (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 pt-0">
        <div>
          <h5 className="mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
            Overview
            {startDate && (
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  marginLeft: "8px",
                  color: "#6C757D",
                }}
              >
                ({formatDateDisplay(startDate)}
                {endDate && startDate.getTime() !== endDate.getTime()
                  ? ` - ${formatDateDisplay(endDate)}`
                  : ""}
                )
              </span>
            )}
          </h5>
        </div>
        <div
          className="d-flex align-items-center gap-2"
          style={{ position: "relative" }}
        >
          <span style={{ fontSize: "14px", color: "#000" }}>Filter by:</span>
          <div style={{ position: "relative" }}>
            <button
              className="btn btn-light d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                padding: 0,
                border: "1px solid #E3EBF8",
              }}
              onClick={() => setOpen(!open)}
            >
              <FaRegCalendarAlt size={14} />
            </button>
            {open && (
              <div
                style={{
                  position: "absolute",
                  top: "40px",
                  right: 0,
                  zIndex: 9999,
                }}
              >
                <DatePicker
                  selected={selectedDate} // Use 'selected' for single date
                  onChange={(date) => setSelectedDate(date)} // date will be a single Date object
                  inline
                />

                {/* <DatePicker
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => handleDateChange(update, false)}
                  inline
                /> */}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="position-relative">
          <input
            ref={appointmentSearchInputRef}
            type="text"
            className="form-control"
            placeholder={`Search`}
            onChange={(e) => {
              const value = e.target.value;
              setSearchDisplayValue(value);
              setAppointmentSearchTerm(value);

              // Clear any existing timeout
              if (searchTimeout) {
                clearTimeout(searchTimeout);
              }

              // If search is cleared, fetch all appointments and hide dropdown
              if (value.length === 0) {
                setShowAppointmentSearchDropdown(false);
                setSelectedDoctorForFilter(null);
                fetchCalendardata(vendorId, currentDate);
                return;
              }

              // Search for doctors if 1 character or more (for dynamic auto-fill)
              if (value.length >= 1) {
                setShowAppointmentSearchDropdown(true);
                const timeoutId = setTimeout(() => {
                  // Use fetchDoctors to search for doctors starting with the search term
                  fetchDoctors(vendorId, "", 1, false, value);
                }, 300); // Reduced debounce time for better responsiveness
                setSearchTimeout(timeoutId);
              }
            }}
            onFocus={() => {
              if (searchDisplayValue.length >= 1) {
                setShowAppointmentSearchDropdown(true);
              }
            }}
            style={{
              height: "40px",
              width: "240px",
              backgroundColor: "#F8F9FA",
              border: "1px solid #E3EBF8",
              borderRadius: "8px",
              paddingLeft: "36px",
              fontSize: "14px",
            }}
          />
          <FaSearch
            className="position-absolute text-muted fs-14"
            style={{ left: "12px", top: "12px" }}
          />
          {searchDisplayValue && (
            <button
              className="btn btn-link position-absolute p-0"
              onClick={() => {
                if (appointmentSearchInputRef.current) {
                  appointmentSearchInputRef.current.value = "";
                }
                setSearchDisplayValue("");
                setAppointmentSearchTerm("");
                setShowAppointmentSearchDropdown(false);
                setSelectedDoctorForFilter(null);
                fetchCalendardata(vendorId, currentDate);
              }}
              style={{
                right: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6C757D",
                cursor: "pointer",
                fontSize: "20px",
              }}
            >
              <FaTimes size={14} />
            </button>
          )}

          {/* Doctor Search Dropdown */}
          {showAppointmentSearchDropdown && doctors.length > 0 && (
            <div
              className="position-absolute bg-white border rounded shadow-sm"
              style={{
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 1000,
                maxHeight: "200px",
                overflowY: "auto",
                marginTop: "4px",
              }}
            >
              {doctors.map((doctor) => (
                <div
                  key={doctor.id}
                  className="p-2 cursor-pointer hover-bg-light"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setSelectedDoctorForFilter(doctor);

                    const doctorNameOnly =
                      doctor.name.charAt(0).toUpperCase() +
                      doctor.name.slice(1).toLowerCase();
                    // Directly set the input value without triggering onChange
                    if (appointmentSearchInputRef.current) {
                      appointmentSearchInputRef.current.value = doctorNameOnly;
                    }
                    setSearchDisplayValue(doctorNameOnly);
                    setAppointmentSearchTerm(doctorNameOnly);
                    setShowAppointmentSearchDropdown(false);
                    // Filter appointments for this doctor
                    filterAppointmentsByDoctor(doctor.id);
                  }}
                >
                  {`${doctor.name.charAt(0).toUpperCase()}${doctor.name
                    .slice(1)
                    .toLowerCase()}`}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <div
            onClick={() => navigate("/vendor_bookings")}
            className="btn-danger rounded p-2 px-3 cursor-pointer "
          >
            New Booking
          </div>
          {/* <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-light d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                padding: 0,
                border: "1px solid #E3EBF8",
              }}
              onClick={() => changeDate(-1)}
            >
              <FaChevronLeft size={14} />
            </button>
            <button
              className="btn btn-dark d-flex align-items-center justify-content-center"
              style={{
                width: "64px",
                height: "32px",
                padding: 0,
                fontSize: "14px",
              }}
            >
              {calendarDate.toDateString() === new Date().toDateString()
                ? "Today"
                : calendarDate.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                  })}
            </button>
            <button
              className="btn btn-light d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                padding: 0,
                border: "1px solid #E3EBF8",
              }}
              onClick={() => changeDate(1)}
            >
              <FaChevronRight size={14} />
            </button>
            <button
              className="btn btn-light d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                padding: 0,
                border: "1px solid #E3EBF8",
              }}
              onClick={handleCalendarDateButtonClick}
            >
              <FaRegCalendarAlt size={14} />
            </button>
            {calendarPickerOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "45px",
                  zIndex: 9999,
                }}
              >
                <DatePicker
                  key={calendarDate.toString()}
                  openToDate={calendarDate}
                  selected={calendarDate}
                  onChange={handleCalendarDateChange}
                  inline
                />
              </div>
            )}
          </div> */}
        </div>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
        {[
          {
            label: <strong>Total</strong>,
            value: orderCounts.total,
            icon: <LuClock style={{ fontSize: "20px", color: "#FF0000" }} />,
            bgColor: "#FDEDED",
            tab: "table",
            status: "All",
          },
          {
            label: <strong>Completed</strong>,
            value: orderCounts.completed,
            icon: (
              <LuClipboardCheck
                style={{ fontSize: "20px", color: "#92007E" }}
              />
            ),
            bgColor: "#FFF0FD",
            tab: "table",
            status: "Completed",
          },
          {
            label: <strong>In Progress</strong>,
            value: orderCounts.progress,
            icon: (
              <HiOutlineUsers style={{ fontSize: "20px", color: "#C75C2C" }} />
            ),
            bgColor: "#FFF0E0",
            tab: "table",
            status: "In Progress",
          },
          {
            label: <strong>Cancelled</strong>,
            value: orderCounts.cancelled,
            icon: (
              <HiOutlineUsers style={{ fontSize: "20px", color: "#037FE8" }} />
            ),
            bgColor: "#F2F9FF",
            tab: "table",
            status: "Cancelled",
          },
        ].map((item, index) => (
          <div className="col" key={index}>
            <div
              className="card d-flex flex-row align-items-center p-3"
              style={{
                cursor: "pointer",
                borderRadius: "12px",
                height: "90px",
                border: "1px solid #E3EBF8",
              }}
              onClick={() => {
                setStatusFilter(item.status);
                handleTabChange(item.tab);
              }}
            >
              <div
                style={{
                  backgroundColor: item.bgColor,
                  borderRadius: "50%",
                  width: "48px",
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "16px",
                }}
              >
                {item.icon}
              </div>
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    color: "#212529",
                    marginBottom: "4px",
                  }}
                >
                  {item.label}
                </div>
                <h5 style={{ fontSize: "18px", fontWeight: "700", margin: 0 }}>
                  {item.value}
                </h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  // Update the table view back button handler
  const renderTableView = () => {
    let mappingColumns = {
      s_no: "S.NO",
      invoice: "Invoice",
      group_id: "Booking ID",
      org_id: "Origin ID",
      partner_name: "Profile",
      user_name: "User Name",
      provider_names: "Provider Name",
      service_name: "Service",
      service_type_name: "Service Type",
      service_offering_name: "Service Offering",
      // group_id: 1,
      service_date: "Service Date",
      service_time: "Service Time",
      discount: "Discount",
      total: "Total",
      booking_status: "Booking Status",
      payment_status: "Payment Status",
    };

    const headers = [
      "Sl. No",
      "Invoice",
      "User Name",
      "Provider",
      "Service",
      "Service Type",
      "Service Offering",
      "Time",
      "Date",
      "Status",
    ];

    const exportHeaders = [
      "Sl. No",
      "Invoice",
      "User Name",
      "Provider",
      "Service",
      "Service Type",
      "Service Offering",
      "Time",
      "Date",
      "Status",
    ];

    // Filter the table data based on status
    const filteredTableData = tableData.filter((row) => {
      // const status = row[5]; // Status is in the 6th column

      // switch (statusFilter) {
      //   case "All":
      //     return true;
      //   case "Active":
      //     return status === "Active";
      //   case "Pending":
      //     return status === "Pending";
      //   case "Completed":
      //     return status === "Completed";
      //   case "No show":
      //     return status === "No Show";
      //   case "Checked In":
      //     return status === "Checked In";
      //   default:
      //     return true;
      // }
      return true;
    });

    const customFilters = (
      <div className="d-flex align-items-center gap-2 position-relative flex-wrap">
        {/* Filter by: Date Range */}
        <span style={{ fontSize: "14px", color: "#000", fontWeight: "600" }}>
          Filter by:
        </span>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn d-flex align-items-center gap-2 px-3"
            style={{
              height: "40px",
              fontSize: "14px",
              borderRadius: "6px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E3EBF8",
              color: "#000000",
            }}
            onClick={() => {
              setOpen(!open);
              setCalendarPickerOpen(false); // close other calendar picker if any
            }}
          >
            {tableStartDate
              ? tableEndDate &&
                tableStartDate.getTime() !== tableEndDate.getTime()
                ? `${formatDateDisplay(tableStartDate)} - ${formatDateDisplay(
                    tableEndDate
                  )}`
                : formatDateDisplay(tableStartDate)
              : "Date"}{" "}
            <FaRegCalendarAlt />
          </button>

          {open && (
            <div
              style={{
                position: "absolute",
                top: "45px",
                left: "0",
                zIndex: 9999,
                backgroundColor: "#fff",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                borderRadius: "8px",
              }}
            >
              <DatePicker
                selectsRange
                startDate={tableStartDate}
                endDate={tableEndDate}
                onChange={(update) => handleDateChange(update, true)}
                inline
              />
            </div>
          )}
        </div>

        {/* Sort by Status */}
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span style={{ fontSize: "14px", color: "#000", fontWeight: "600" }}>
            Sort by:
          </span>
          <div className="btn-group">
            {[
              "All",
              "Completed",
              "In Progress",
              "Cancelled",
              "Generate Invoice",
            ].map((label) => (
              <button
                key={label}
                className={`btn px-3 ${
                  statusFilter === label ? "btn-primary" : ""
                }`}
                style={{
                  height: "40px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  marginRight: "10px",
                  backgroundColor:
                    statusFilter === label ? "#FFF7F9" : "#FFFFFF",
                  border:
                    statusFilter === label
                      ? "1px solid #C9194A"
                      : "1px solid #E3EBF8",
                  color: "#000000",
                }}
                onClick={() => {
                  setStatusFilter(label);
                  setCurrentPage(1); // Reset pagination
                }}
              >
                {label}
              </button>
            ))}
          </div>
          <button
            className="btn px-3"
            style={{
              height: "40px",
              fontSize: "14px",
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #E3EBF8",
              color: "#000000",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={() => {
              // Create CSV content with Age, Gender, Phone Number (export only)
              const csvContent = [
                exportHeaders.join(","),
                ...filteredTableData.map((row) =>
                  [
                    row[0], // Sl. No
                    row[1], // Patient Name
                    row[2], // Doctor
                    row[3], // Time Slot
                    row[4], // Date
                    row[5], // Status
                    row[6], // Age
                    row[7], // Gender
                    row[8], // Phone Number
                  ].join(",")
                ),
              ].join("\n");

              // Create and trigger download
              const blob = new Blob([csvContent], {
                type: "text/csv;charset=utf-8;",
              });
              const link = document.createElement("a");
              const url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute(
                "download",
                `appointments_${new Date().toISOString().split("T")[0]}.csv`
              );
              link.style.visibility = "hidden";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            <img
              src={ExcelIcon}
              alt="Excel"
              style={{ width: "20px", height: "20px" }}
            />
            Export
          </button>
        </div>
      </div>
    );
    const onBackClick = () => {
      handleTabChange("dashboard");
    };

    const newBookingNavigate = (data) => {
      navigate(`/vendor_bookings/${data}`);
    };

    return (
      <div>
        <div className="d-flex align-items-center mb-3">
          <button
            className="btn btn-link text-dark p-0"
            onClick={onBackClick}
            style={{ fontSize: "14px", textDecoration: "none" }}
          >
            <MdArrowBack size={20} /> BACK
          </button>
        </div>
        {customFilters}
        <div className="bg-white mt-3 rounded-2">
          <div className="table-responsive">
            <Table
              bordered
              hover
              className="align-middle mb-0 bg-custom-light border-custom custom-table dashboardTable "
              style={{ fontSize: "14px" }}
            >
              <thead>
                <tr className="table-header-row">
                  {mappingColumns &&
                    Object.values(mappingColumns)?.map((header, idx) => (
                      <th key={idx}>{header}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array(10)
                    .fill(null)
                    .map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="30px" />
                        </td>
                        <td>
                          <Skeleton width="30px" />
                        </td>
                        <td>
                          <Skeleton width="150px" />
                        </td>
                        <td>
                          <Skeleton width="120px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <Skeleton width="100px" />
                        </td>
                        <td>
                          <Skeleton width="80px" />
                        </td>
                        <td>
                          <div className="d-flex gap-3">
                            <Skeleton width="80px" />
                            <Skeleton width="80px" />
                          </div>
                        </td>
                      </tr>
                    ))
                ) : (
                  <Fragment>
                    {tableData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1} </td>
                          <td>
                            <input type="checkbox" />{" "}
                          </td>
                          {mappingColumns &&
                            Object.keys(mappingColumns)?.map((col, idx) => {
                              return (
                                <>
                                  {![0, 1].includes(idx) && (
                                    <>
                                      {col === "group_id" ? (
                                        <td
                                          className="linkText cursor-pointer"
                                          onClick={() =>
                                            newBookingNavigate(data[col])
                                          }
                                          key={idx}
                                        >
                                          {data[col]}
                                        </td>
                                      ) : (
                                        <td key={idx}>{data[col]}</td>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            })}
                        </tr>
                      );
                    })}
                  </Fragment>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  // Update the calendar view date picker button click handler
  const handleCalendarDateButtonClick = () => {
    setCalendarPickerOpen(!calendarPickerOpen);
    setOpen(false); // Close the table view date picker
  };

  //function call to convert the time slots to 24 hours format
  const convertSlotsTo24HourFormat = (slots) => {
    return slots.map((slot) => {
      const [time, modifier] = slot.trim().split(" ");
      let [hours, minutes] = time.split(":");
      hours = parseInt(hours, 10);

      if (modifier.toUpperCase() === "PM" && hours < 12) hours += 12;
      if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;

      return `${hours.toString().padStart(2, "0")}:${minutes}`;
    });
  };

  //api function to handle the book appointment
  const handleBookAppointmentApi = async (payload) => {
    try {
      const response = await apicall.post(payload, "book-appointment");

      if (response.status === 200) {
        toast.success("Appointment booked successfully");
        setFormData({
          mobileNumber: "",
          patientName: "",
          age: "",
          gender: "",
          insuranceNumber: "",
          insuranceProvider: "",
          specialization: "",
          doctorName: "",
          appointmentDate: "",
          selectedTimeSlots: [],
        });
        fetchCalendardata(vendorId);
      } else {
        console.log("response", response.message);
      }
    } catch (error) {
      console.error("Error creating availability:", error);
      toast.error(error?.message || "Failed to book appointment");
    }
  };

  //function call to fetch available slots
  const getDatesInRange = (startDateStr, endDateStr) => {
    const dates = [];

    // Extract just the date parts (YYYY-MM-DD)
    const startDateOnly = startDateStr.split(" ")[0];
    const endDateOnly = endDateStr.split(" ")[0];

    // Parse dates without timezone considerations
    const [startYear, startMonth, startDay] = startDateOnly
      .split("-")
      .map(Number);
    const [endYear, endMonth, endDay] = endDateOnly.split("-").map(Number);

    const start = new Date(startYear, startMonth - 1, startDay);
    const end = new Date(endYear, endMonth - 1, endDay);

    let current = new Date(start);
    while (current <= end) {
      // Format as YYYY-MM-DD using local date components
      const dateStr = [
        current.getFullYear(),
        String(current.getMonth() + 1).padStart(2, "0"),
        String(current.getDate()).padStart(2, "0"),
      ].join("-");

      dates.push(dateStr);
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  //function call to handle to get the holidays of the doctor

  const fetchDoctorHolidays = async (doctorId) => {
    try {
      const response = await apicall.get(`get_holidays?user_id=${doctorId}`);
      if (response.status === 200) {
        const allHolidayDates = response.data.flatMap((holiday) =>
          getDatesInRange(holiday.holiday_start, holiday.holiday_end)
        );
        // Remove duplicates and sort
        const uniqueUnavailableDates = [...new Set(allHolidayDates)].sort();
        setHolidaysDates(uniqueUnavailableDates);
      } else {
        console.log("response", response.message);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
      toast.error("Failed to fetch holidays");
    }
  };

  const normalize = (str) => str.toLowerCase().replace(/\s+/g, " ").trim();
  const filteredAppointments = appointments.filter((appointment) => {
    if (!appointmentSearchTerm) return true;
    return normalize(appointment.search).includes(
      normalize(appointmentSearchTerm)
    );
  });

  // Add cleanup for search timeout
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  // Add this useEffect after other useEffect declarations
  useEffect(() => {
    function handleClickOutside(event) {
      // Handle Doctor dropdown
      if (
        doctorDropdownRef.current &&
        !doctorDropdownRef.current.contains(event.target)
      ) {
        setDoctorDropdownOpen(false);
      }

      // Handle Appointment Search dropdown - check if click is outside the entire search container
      if (appointmentSearchInputRef.current) {
        const searchContainer = appointmentSearchInputRef.current.parentElement;
        if (searchContainer && !searchContainer.contains(event.target)) {
          setShowAppointmentSearchDropdown(false);
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Function to filter appointments by selected doctor
  const filterAppointmentsByDoctor = async (doctorId) => {
    try {
      const response = await apicall.get(
        `get_booking_details/${currentDate}/${vendorId}?doctor_id=${doctorId}`
      );
      if (response.status === 200) {
        const filteredData = response.data.filter((item) => item.status !== 14);
        setCalendarAppointmentData(filteredData);
      }
    } catch (error) {
      console.error("Error filtering appointments by doctor:", error);
      toast.error("Failed to filter appointments");
    }
  };

  return (
    <div className="container-fluid">
      {/* Show skeleton loader while vendor data is loading */}
      {!vendor ? (
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-4 pt-4">
            <Skeleton width="200px" height="24px" />
            <Skeleton width="150px" height="32px" />
          </div>

          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-3 mb-4">
            {[1, 2, 3, 4].map((item) => (
              <div className="col" key={item}>
                <div
                  className="card d-flex flex-row align-items-center p-3"
                  style={{
                    borderRadius: "12px",
                    height: "90px",
                    border: "1px solid #E3EBF8",
                  }}
                >
                  <Skeleton
                    width="48px"
                    height="48px"
                    marginBottom="0"
                    style={{ borderRadius: "50%", marginRight: "16px" }}
                  />
                  <div style={{ flex: 1 }}>
                    <Skeleton width="80px" height="16px" marginBottom="4px" />
                    <Skeleton width="40px" height="24px" marginBottom="0" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-12 col-xl-8">
              <Skeleton width="200px" height="24px" marginBottom="16px" />
              <div className="d-flex justify-content-between align-items-center mb-4">
                <Skeleton width="240px" height="40px" />
                <div className="d-flex gap-2">
                  <Skeleton width="32px" height="32px" />
                  <Skeleton width="64px" height="32px" />
                  <Skeleton width="32px" height="32px" />
                  <Skeleton width="32px" height="32px" />
                </div>
              </div>
              <div className="card border-0">
                <div className="card-body p-0">
                  <Skeleton width="100%" height="720px" />
                </div>
              </div>
            </div>

            <div className="col-12 col-xl-4">
              <div
                className="card border-0 rounded-2"
                style={{ marginTop: "2.5rem" }}
              >
                <div className="bg-primary px-4 py-3 border-bottom border-white">
                  <Skeleton
                    width="150px"
                    height="24px"
                    style={{ backgroundColor: "rgba(255,255,255,0.3)" }}
                  />
                </div>
                <div
                  className="card-body p-4"
                  style={{ backgroundColor: "#0D6EFD", minHeight: "600px" }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                    <div key={item} className="mb-3">
                      <Skeleton
                        width="100px"
                        height="16px"
                        marginBottom="8px"
                        style={{ backgroundColor: "rgba(255,255,255,0.3)" }}
                      />
                      <Skeleton
                        width="100%"
                        height="40px"
                        style={{ backgroundColor: "rgba(255,255,255,0.3)" }}
                      />
                    </div>
                  ))}
                  <div className="d-flex gap-2">
                    <Skeleton
                      width="50%"
                      height="40px"
                      style={{ backgroundColor: "rgba(255,255,255,0.3)" }}
                    />
                    <Skeleton
                      width="50%"
                      height="40px"
                      style={{ backgroundColor: "rgba(255,255,255,0.3)" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {activeTab !== "dashboard" ? (
            renderTableView()
          ) : (
            <>
              {renderOverview()}
              <div className="row">
                {/* <div className="col-12 col-xl-8"> */}
                <div className="col-12">
                  {/* <h5 className="mb-2">Appointment Schedule</h5> */}

                  <div className="card border-0">
                    <div className="card-body p-34 border-box	">
                      <div
                        className="position-relative removeHeader"
                        style={{ minHeight: "720px" }}
                      >
                        <CustomCalendar
                          events={filteredAppointments}
                          date={currentDate}
                          onAppointmentClick={handleAppointmentClick}
                          startTime={vendor?.working_hours_start}
                          endTime={vendor?.working_hours_end}
                          scrollToEventId="event-1"
                          headerToolbar={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default NewDashboard;
